export default __webpack_public_path__ + "static/media/lanceroOpen.d84e0c41.jpg";